import { LoginCallback, useOktaAuth } from "@okta/okta-react";
import React from "react";
import { Redirect, Route, Switch, useHistory } from "react-router";
import { oktaInternalAuthConfig } from "../lib/auth-config";
import LoginSSOView from "../views/LoginSSOView";
import LoginView from "../views/LoginView";
import AuthenticatedLayout from "../views/_AuthenticatedLayout";
import GuardedRoute from "./GuardedRoute";
import { routes } from "./index";

function AppRoutes() {
  const history = useHistory();
  const okta = useOktaAuth();
  const { authState } = okta;

  if (!authState) {
    if (!history.location.pathname.includes("callback")) {
      return null;
    }
  }

  const onAuthResume = async () => {
    history.push("/login");
  };

  const isLoggedIn = authState?.isAuthenticated;

  return (
    <Switch>
      <Route
        exact
        path="/login"
        render={() => <LoginView config={oktaInternalAuthConfig} />}
      />

      <Route exact path="/login/employee">
        <Redirect to="/login" />
      </Route>

      <Route
        exact
        path="/login/callback"
        render={(props) => (
          <LoginCallback {...props} onAuthResume={onAuthResume} />
        )}
      />

      <Route exact path="/login/sso" render={() => <LoginSSOView />} />

      <Route>
        {isLoggedIn ? (
          <AuthenticatedLayout>
            <Switch>
              {routes.map(
                ({ exact, path, Component, secured, roles, fallback }, key) =>
                  secured ? (
                    <GuardedRoute
                      exact={exact}
                      path={path}
                      key={key}
                      component={Component}
                      rolesNeededtoActivateRoute={roles ?? []}
                      fallback={fallback ?? ""}
                    />
                  ) : (
                    <Route
                      exact={exact}
                      path={path}
                      key={key}
                      render={Component}
                    />
                  )
              )}
            </Switch>
            <Route exact path="/">
              <Redirect to="/quotes/my-quotes" />
            </Route>
          </AuthenticatedLayout>
        ) : (
          <Redirect to="/login" />
        )}
      </Route>
    </Switch>
  );
}
export default AppRoutes;
